var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageMaintenance"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }